/*jshint esversion: 6*/
import t from '../../translate.js'
import * as d3 from "d3v4";
import * as c3 from 'c3';
import 'c3/c3.css';

// import * as db from './data.js';
// import * as field_manager from './field_manager.js';

export function drawIrriWidget(div,data){

  // console.log(data);
  var res=data.result_summary;
  var balance=doBalance(res,div);

  if(res.harvested===true){
    var sum_irri_auto=res.irri_auto;
    var iauto='';
    var sub=("The crop development is terminated on")+" "+res.datetime+". ";
    if(sum_irri_auto>0){
      var mm=iauto+=("The total amount of irrigation water is")+" "+parseFloat(sum_irri_auto).toFixed(0)+" mm.";
      sub+=iauto;
      iauto="<h4>"+iauto+"</h4>";
    }

    // self.theme.setContent({'main':("Concluded cycle"),
    //   'sub': sub,
    //   'pictogram':"<div><h1>"+("Concluded cycle")+"</h1>"+iauto+"</div>", 'alert_level':'info' });
  }
  else{
    var pictogram="<svg id='model_irripict' width='250' height='250' style='border-radius:300px;'></svg>";
    // self.theme.setContent({'main':balance.title, 'sub': balance.sub, 'pictogram':pictogram, 'alert_level':balance.alert_level });
    jQuery(div).html(pictogram);
    jQuery(div+' svg').css('background',balance.irri_config.waveTextColor);

    var Irri_widget = loadLiquidFillGauge("model_irripict", res.last_record.deficit.toFixed(0), res.last_record.water_need.toFixed(0), balance.irri_config);

    var riassunto=`
    <table class="data-table">
      <tr><th>${t('Data')}</th><td>${res.last_record.date}</td></tr>
    </table>
    <h3>${t('Ultimi 7 giorni')}</h3>
    <table class="data-table">
      <tr><th>${t('ETc media')}</th><td>${res.last_week.ETc_avg.toFixed(2)} mm</td></tr>
      <tr><th>${t('ETc cumulata')}</th><td>${res.last_week.ETc.toFixed(2)} mm</td></tr>
      <tr><th>${t('Pioggia')}</th><td>${res.last_week.rain.toFixed(2)} mm</td></tr>
    </table>
    <hr>

    <h3>${t('Periodo')}</h3>
    <table class="data-table">
      <tr><th>${t('Data inizio')}</th><td>${data.body.crop.date_start}</td></tr>
      <tr><th>${t('Data fine')}</th><td>${data.final_value.model_end?data.result_summary.date_end:data.body.crop.date_end}</td></tr>
      <tr><th>${t('ETc cumulata')}</th><td>${res.ETc_mm_tot.toFixed(2)} mm</td></tr>
      <tr><th>${t('Pioggia')}</th><td>${res.rain_mm_tot.toFixed(2)} mm</td></tr>
      <tr><th>${t('Giorni di stress idrico')}</th><td>${res.ks_count} ${res.ks_count!=1?t('giorni'):t('giorno')}</td></tr>
      <tr><th>${t('Irrigazioni automatiche')}</th><td>${res.water_applied_auto.toFixed(2)} mm</td></tr>
      <tr><th>${t('Irrigazioni effettuate')}</th><td>${res.water_applied_farmer.toFixed(2)} mm</td></tr>
    </table>
    `;
    jQuery(div).append(riassunto);

  }
}

export function doBalance(res,div){
  var optimal_level=res.last_record.opt_thr_mm;
  var critical_level=res.last_record.cri_thr_mm;
  //numero di giorni con acqua sufficente per non superare la soglia critica in assenza di piogge
  var max_day_before_alert=3;

  var suggested_irrigation=0;

  var irri_config = liquidFillGaugeDefaultSettings();
  var title="";
  var sub="";
  var alert_level='info';

  if(res.last_record.deficit>optimal_level){
    irri_config.text = "Ok";
    title=("Ok")+"!";
    sub=("No need of irrigation. Soil is at saturation: moisture is at its maximum")+".";
    suggested_irrigation=0;
  }
  else if(res.last_record.deficit>critical_level){
    alert_level='low';
    if( (res.last_record.deficit-critical_level)/res.etc>max_day_before_alert ){
      irri_config.circleColor = "#DCEDC8";
      irri_config.textColor = "#C5E1A5";
      irri_config.waveTextColor = "#4CAF50";
      irri_config.waveColor = "#A5D6A7";
      irri_config.text = ("Ok");
      title=t("Ok")+".";
      sub=("No need of irrigation: water available in the soil is at")+" "+(optimal_level-res.last_record.deficit).toFixed(1)+("mm from the optimal level")+".";
    }
    else{
      alert_level='medium';
      irri_config.circleColor = "#FFECB3";
      irri_config.textColor = "#FFE082";
      irri_config.waveTextColor = "#FFCA28";
      irri_config.waveColor = "#FFF59D";
      irri_config.text = ("Alert");
      title=t("Alert")+".";
      sub=("Irrigation requirements in")+" "+Math.round((res.last_record.deficit-critical_level)/res.etc)+" "+("days: water available in the soil is at")+" "+res.last_record.deficit.toFixed(2)+("mm from the optimal level")+".";
    }
  }
  else{
    alert_level='high';
    irri_config.circleColor = "#FFCDD2";//100
    irri_config.textColor = "#EF9A9A";//200
    irri_config.waveTextColor = "#E57373";//300
    irri_config.waveColor = "#EF9A9A";//200
    irri_config.text = ("Irrigate");
    title=t("Irrigate")+'.';
    sub=("The crop needs to be irrigated")+": "+(optimal_level-res.last_record.deficit).toFixed(1)+" mm</b>! "+("")+".";
  }

  if (typeof res.last_record.water_applied_auto!='undefined' && res.last_record.water_applied_auto>0) {
    // title+=" "+res.last_record.water_applied_auto+'mm';
    suggested_irrigation=res.last_record.water_applied_auto;
  }

  var dry=-60;
  dry=Math.max(-60,critical_level*2);
  if(res.last_record.deficit<dry){
    dry=res.last_record.deficit*2;
  }

  console.log("IRRI_CONFIG",irri_config);
  return {"suggested_irrigation": suggested_irrigation, "irri_config":irri_config, "title":title, "sub":sub, "alert_level":alert_level,"dry":dry };
}



/*!
 * @license Open source under BSD 2-clause (http://choosealicense.com/licenses/bsd-2-clause/)
 * Copyright (c) 2015, Curtis Bratton
 * All rights reserved.
 *
 * Liquid Fill Gauge v1.1
 */
function liquidFillGaugeDefaultSettings(){
    return {
        minValue: 0, // The gauge minimum value.
        maxValue: 100, // The gauge maximum value.
        circleThickness: 0.05, // The outer circle thickness as a percentage of it's radius.
        circleFillGap: 0.05, // The size of the gap between the outer circle and wave circle as a percentage of the outer circles radius.
        circleColor: "#178BCA", // The color of the outer circle.
        waveHeight: 0.1, // The wave height as a percentage of the radius of the wave circle.
        waveCount: 2, // The number of full waves per width of the wave circle.
        waveRiseTime: 2000, // The amount of time in milliseconds for the wave to rise from 0 to it's final height.
        waveAnimateTime: 1500, // The amount of time in milliseconds for a full wave to enter the wave circle.
        waveRise: true, // Control if the wave should rise from 0 to it's full height, or start at it's full height.
        waveHeightScaling: true, // Controls wave size scaling at low and high fill percentages. When true, wave height reaches it's maximum at 50% fill, and minimum at 0% and 100% fill. This helps to prevent the wave from making the wave circle from appear totally full or empty when near it's minimum or maximum fill.
        waveAnimate: true, // Controls if the wave scrolls or is static.
        waveColor: "#178BCA", // The color of the fill wave.
        waveOffset: 0.25, // The amount to initially offset the wave. 0 = no offset. 1 = offset of one full wave.
        textVertPosition: 0.5, // The height at which to display the percentage text withing the wave circle. 0 = bottom, 1 = top.
        textSize: 1, // The relative height of the text to display in the wave circle. 1 = 50%
        valueCountUp: false, // If true, the displayed value counts up from 0 to it's final value upon loading. If false, the final value is displayed.
        displayPercent: true, // If true, a % symbol is displayed after the value.
        textColor: "#045681", // The color of the value text when the wave does not overlap it.
        waveTextColor: "#A4DBf8", // The color of the value text when the wave overlaps it.
        text:"Inserisci il testo"
    };
}

export function loadLiquidFillGauge(elementId, value_real_mm, water_need, config) {


    var scale_value = d3.scaleLinear()
      .domain([-60,0])
      .range([0,100]);
    var value=scale_value(value_real_mm);

    if(typeof config === "undefined") config = liquidFillGaugeDefaultSettings();

    var gauge = d3.select('#'+elementId);

    var radius = Math.min(parseInt(gauge.style("width")), parseInt(gauge.style("height")))/2;

    var locationX = parseInt(gauge.style("width"))/2 - radius;
    var locationY = parseInt(gauge.style("height"))/2 - radius;
    var fillPercent = Math.max(config.minValue, Math.min(config.maxValue, value))/config.maxValue;

    var waveHeightScale;
    if(config.waveHeightScaling){
        waveHeightScale = d3.scaleLinear()
            .range([0,config.waveHeight,0])
            .domain([0,50,100]);
    } else {
        waveHeightScale = d3.scaleLinear()
            .range([config.waveHeight,config.waveHeight])
            .domain([0,100]);
    }
    var textPixels;
    if (config.text=='Attenzione') {
      textPixels = (config.textSize*radius/3);
    }
    else {
      textPixels = (config.textSize*radius/2);
    }
    var textFinalValue = parseFloat(value).toFixed(2);
    var textStartValue = config.valueCountUp?config.minValue:textFinalValue;
    var percentText = config.displayPercent?"%":"";
    var circleThickness = config.circleThickness * radius;
    var circleFillGap = config.circleFillGap * radius;
    var fillCircleMargin = circleThickness + circleFillGap;
    var fillCircleRadius = radius - fillCircleMargin;
    var waveHeight = fillCircleRadius*waveHeightScale(fillPercent*100);

    var waveLength = fillCircleRadius*2/config.waveCount;
    var waveClipCount = 1+config.waveCount;
    var waveClipWidth = waveLength*waveClipCount;

    // Rounding functions so that the correct number of decimal places is always displayed as the value counts up.
    var textRounder = function(value){ return Math.round(value); };
    if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
        textRounder = function(value){ return parseFloat(value).toFixed(1); };
    }
    if(parseFloat(textFinalValue) != parseFloat(textRounder(textFinalValue))){
        textRounder = function(value){ return parseFloat(value).toFixed(2); };
    }

    // Data for building the clip wave area.
    var data = [];
    for(var i = 0; i <= 40*waveClipCount; i++){
        data.push({x: i/(40*waveClipCount), y: (i/(40))});
    }

    // Scales for drawing the outer circle.
    var gaugeCircleX = d3.scaleLinear().range([0,2*Math.PI]).domain([0,1]);
    var gaugeCircleY = d3.scaleLinear().range([0,radius]).domain([0,radius]);

    // Scales for controlling the size of the clipping path.
    var waveScaleX = d3.scaleLinear().range([0,waveClipWidth]).domain([0,1]);
    var waveScaleY = d3.scaleLinear().range([0,waveHeight]).domain([0,1]);

    // Scales for controlling the position of the clipping path.
    var waveRiseScale = d3.scaleLinear()
        // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
        // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
        // circle at 100%.
        .range([(fillCircleMargin+fillCircleRadius*2+waveHeight),(fillCircleMargin-waveHeight)])
        .domain([0,1]);
    var waveAnimateScale = d3.scaleLinear()
        .range([0, waveClipWidth-fillCircleRadius*2]) // Push the clip area one full wave then snap back.
        .domain([0,1]);

    // Scale for controlling the position of the text within the gauge.
    var textRiseScaleY = d3.scaleLinear()
        .range([fillCircleMargin+fillCircleRadius*2,(fillCircleMargin+textPixels*0.7)])
        .domain([0,1]);

    // Center the gauge within the parent SVG.
    var gaugeGroup = gauge.append("g")
        .attr('transform','translate('+0+','+0+')');

    // Draw the outer circle.
    var gaugeCircleArc = d3.arc()
        .startAngle(gaugeCircleX(0))
        .endAngle(gaugeCircleX(1))
        .outerRadius(gaugeCircleY(radius))
        .innerRadius(gaugeCircleY(radius-circleThickness));
    gaugeGroup.append("path")
        .attr("d", gaugeCircleArc)
        .style("fill", 'white')
        .attr('transform','translate('+radius+','+radius+')');

    // Text where the wave does not overlap.
    // debugger
    var text1 = gaugeGroup.append("text")
        .text(config.text)
        .attr("class", "liquidFillGaugeText")
        .attr("text-anchor", "middle")
        .attr("font-size", textPixels + "px")
        .style("fill", 'white')
        .attr('transform','translate('+radius+','+(textRiseScaleY(config.textVertPosition)-30)+')');
    var text2 = gaugeGroup.append("text")
        .text((water_need)+" mm")
        // .text(config.text)
        .attr("class", "liquidFillGaugeText")
        .attr("text-anchor", "middle")
        .attr("font-size", (textPixels-20) + "px")
        .style("fill", 'white')
        .attr('transform','translate('+radius+','+(textRiseScaleY(config.textVertPosition)+30)+')');

    // The clipping wave area.
    var clipArea = d3.area()
        .x(function(d) { return waveScaleX(d.x); } )
        .y0(function(d) { return waveScaleY(Math.sin(Math.PI*2*config.waveOffset*-1 + Math.PI*2*(1-config.waveCount) + d.y*2*Math.PI));} )
        .y1(function(d) { return (fillCircleRadius*2 + waveHeight); } );
    var waveGroup = gaugeGroup.append("defs")
        .append("clipPath")
        .attr("id", "clipWave" + elementId);
    var wave = waveGroup.append("path")
        .datum(data)
        .attr("d", clipArea)
        .attr("T", 0);

    // The inner circle with the clipping wave attached.
    var fillCircleGroup = gaugeGroup.append("g")
        .attr("clip-path", "url(#clipWave" + elementId + ")");
    fillCircleGroup.append("circle")
        .attr("cx", radius)
        .attr("cy", radius)
        .attr("r", fillCircleRadius)
        .style("fill", 'white')
        .style('opacity',0.5);

    // debugger
    // Text where the wave does overlap.
    // var text2 = fillCircleGroup.append("text")
    //     .text(value_real_mm+" mm")
    //     // .text(config.text)
    //     .attr("class", "liquidFillGaugeText")
    //     .attr("text-anchor", "middle")
    //     .attr("font-size", textPixels + "px")
    //     .style("fill", 'white')
    //     .attr('transform','translate('+radius+','+textRiseScaleY(config.textVertPosition)+')');

    // Make the value count up.
    if(config.valueCountUp){
        var textTween = function(){
            var i = d3.interpolate(this.textContent, textFinalValue);
            return function(t) { this.textContent = textRounder(i(t)) + percentText; };
        };
        // text1.transition()
        //     .duration(config.waveRiseTime)
        //     .tween("text", textTween);
        // text2.transition()
        //     .duration(config.waveRiseTime)
        //     .tween("text", textTween);
    }

    // Make the wave rise. wave and waveGroup are separate so that horizontal and vertical movement can be controlled independently.
    var waveGroupXPosition = fillCircleMargin+fillCircleRadius*2-waveClipWidth;
    if(config.waveRise){
        waveGroup.attr('transform','translate('+waveGroupXPosition+','+waveRiseScale(0)+')')
            .transition()
            .duration(config.waveRiseTime)
            .attr('transform','translate('+waveGroupXPosition+','+waveRiseScale(fillPercent)+')')
            .on("start", function(){ wave.attr('transform','translate(1,0)'); }); // This transform is necessary to get the clip wave positioned correctly when waveRise=true and waveAnimate=false. The wave will not position correctly without this, but it's not clear why this is actually necessary.
    } else {
        waveGroup.attr('transform','translate('+waveGroupXPosition+','+waveRiseScale(fillPercent)+')');
    }


    function animateWave() {
        // console.log("ANIMATING WAVE");

        wave.attr('transform','translate('+waveAnimateScale(wave.attr('T'))+',0)');
        wave.transition()
            .duration(config.waveAnimateTime * (1-wave.attr('T')))
            .ease(d3.easeLinear)
            .attr('transform','translate('+waveAnimateScale(1)+',0)')
            .attr('T', 1)
            .on('end', function(){
                wave.attr('T', 0);
                animateWave(config.waveAnimateTime);
            });
    }
    if(config.waveAnimate) animateWave();

    function GaugeUpdater(){
        this.update = function(value){
            var newFinalValue = parseFloat(value).toFixed(2);
            var textRounderUpdater = function(value){ return Math.round(value); };
            if(parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))){
                textRounderUpdater = function(value){ return parseFloat(value).toFixed(1); };
            }
            if(parseFloat(newFinalValue) != parseFloat(textRounderUpdater(newFinalValue))){
                textRounderUpdater = function(value){ return parseFloat(value).toFixed(2); };
            }

            var textTween = function(){
                var i = d3.interpolate(this.textContent, parseFloat(value).toFixed(2));
                return function(t) { this.textContent = textRounderUpdater(i(t)) + percentText; };
            };

            text1.transition()
                .duration(config.waveRiseTime)
                .tween("text", textTween);
            text2.transition()
                .duration(config.waveRiseTime)
                .tween("text", textTween);

            var fillPercent = Math.max(config.minValue, Math.min(config.maxValue, value))/config.maxValue;
            var waveHeight = fillCircleRadius*waveHeightScale(fillPercent*100);
            var waveRiseScale = d3.scaleLinear()
                // The clipping area size is the height of the fill circle + the wave height, so we position the clip wave
                // such that the it will overlap the fill circle at all when at 0%, and will totally cover the fill
                // circle at 100%.
                .range([(fillCircleMargin+fillCircleRadius*2+waveHeight),(fillCircleMargin-waveHeight)])
                .domain([0,1]);
            var newHeight = waveRiseScale(fillPercent);
            var waveScaleX = d3.scaleLinear().range([0,waveClipWidth]).domain([0,1]);
            var waveScaleY = d3.scaleLinear().range([0,waveHeight]).domain([0,1]);
            var newClipArea;
            if(config.waveHeightScaling){
                newClipArea = d3.area()
                    .x(function(d) { return waveScaleX(d.x); } )
                    .y0(function(d) { return waveScaleY(Math.sin(Math.PI*2*config.waveOffset*-1 + Math.PI*2*(1-config.waveCount) + d.y*2*Math.PI));} )
                    .y1(function(d) { return (fillCircleRadius*2 + waveHeight); } );
            } else {
                newClipArea = clipArea;
            }

            var newWavePosition = config.waveAnimate?waveAnimateScale(1):0;
            wave.transition()
                .duration(0)
                .transition()
                .duration(config.waveAnimate?(config.waveAnimateTime * (1-wave.attr('T'))):(config.waveRiseTime))
                .ease('linear')
                .attr('d', newClipArea)
                .attr('transform','translate('+newWavePosition+',0)')
                .attr('T','1')
                .on('end', function(){
                    if(config.waveAnimate){
                        wave.attr('transform','translate('+waveAnimateScale(0)+',0)');
                        animateWave(config.waveAnimateTime);
                    }
                });
            waveGroup.transition()
                .duration(config.waveRiseTime)
                .attr('transform','translate('+waveGroupXPosition+','+newHeight+')');
        };
    }
    return new GaugeUpdater();
}


export function drawIrriDetail(data_model,guid_farm,guid_field){

  var div='';
  div+="<h1>Modello di irrigazione</h1>";

  div+='<div class="row">';
    div+='<div class="col-xs-10"><div id="irri_chart"></div></div>';
    div+='<div id="irri_auto" class="col-xs-2"></div>';
  div+='</div>';

  div+='<div id="irri_table"></div>';
  jQuery('#aeco_content').html(div);


  var button_class='not_checked';
  // if (typeof previuos_irrigations=='undefined' || previuos_irrigations.length==0) {
    // jQuery('#irrigazione_aggiuntiva').hide();
  // }
  if (false) {
    button_class='checked';
    jQuery('#irrigazione_aggiuntiva').show();
  }


  var irrigation='<h2>Irrigazione automatica</h2><label class="switch">';
    irrigation+='<input type="checkbox" '+button_class+'>';
    irrigation+='<span  id="btn_auto_irrigazione" class="slider round '+button_class+'"></span>';
  irrigation+='</label>';
  jQuery('#irri_auto').html(irrigation);

  db.getField(guid_farm, guid_field, function(data){
    var farm_center=data.farm_center;
    var field_data=data.field;

    var server_state=false;
    if (field_data.auto_irrigation==1) {
      server_state=true;
    }

    jQuery('#irri_auto input').prop('checked', server_state);
    jQuery('#irri_auto input').click(function(){

        var auto_irrigation=0;
        if (jQuery('#irri_auto input').is(':checked')==true) {
          auto_irrigation=1;
        }
        field_data.auto_irrigation=auto_irrigation;

        var not_reload=false;
        field_manager.aeco_field_save(farm_center, field_data, not_reload);
    });


    console.log(data_model);
    jQuery('script[src="sites/all/libraries/external_resources/d3/d3.v4.min.js"]').remove();

    jQuery.getScript( "//cdnjs.cloudflare.com/ajax/libs/d3/3.5.4/d3.min.js", function(){
      var chart=drawChart(data_model.results,'irri_chart');
    });

    jQuery('script[src="//cdnjs.cloudflare.com/ajax/libs/d3/3.5.4/d3.min.js"]').remove();

    drawTable(data_model,'#irri_table',field_data.auto_irrigation);
  });


}

function drawTable(data_all,div,auto_irrigation){
  var data=reverseArr(data_all.results);

  var format=[
    {'field':'date','label':t('Date'),
      'format': function(d){
        var val=parseFloat(d);
        var aDate=d.split('-');
        var txt=aDate[2]+"/"+aDate[1]+"/"+aDate[0];
        return txt;
      }
    },
    // {'field':'stage','label':'Fenologia',
    //   'format': function(d){
    //     var val=t(d);
    //     var txt=val;
    //     return txt;
    //   }
    // },
    {'field':'ET0','label':'ET<span class="sipm_smaller_font_size">0</span> (mm)',
      'format': function(d){
        var val=parseFloat(d);
        var txt=val.toFixed(2);
        return txt;
      }
    },

    {'field':'kc','label':'kc',
      'format': function(d){
        var val=parseFloat(d);
        var txt=val.toFixed(2);
        return txt;
      }
    },
    {'field':'ks','label':'ks',
      'format': function(d){
        var val=parseFloat(d);
        var txt=val.toFixed(2);
        return txt;
      }
    },
    {'field':'ETc','label':'ET<span class="sipm_smaller_font_size">C</span> (mm)',
      'format': function(d){
        var val=parseFloat(d);
        var txt=val.toFixed(2);
        return txt;
      }
    },
    {'field':'rain','label':t('Rain')+' (mm)',
      'format': function(d){
        var val=parseFloat(d);
        var txt=val.toFixed(2);
        return txt;
      }
    },



  ];

  console.log("auto_",auto_irrigation);
  if (auto_irrigation!=1) {
    format.push({'field':'deficit','label':t('Water state'),
      'format': function(d, v){
        var txt="";

        // console.log("V",v);
        // console.log("-----");
        // console.log("D",d);
        var bal=doBalance({"last_record":v});
        // var bal=v;

        txt+="<span class='badge badge_level_"+bal.alert_level+"' title='"+bal.sub+"'>"+bal.title+"</span>";
        //debugger
        if(bal.suggested_irrigation>0){
          txt+=" "+bal.suggested_irrigation.toFixed(1)+"mm";
        }
        return txt;
      }
    });
    format.push({'field':'water_need','label':t('Suggestion')+' (mm)',
      'format': function(d, v){
        var txt="";
        var val=parseFloat(d);
        if(val>0){
          txt+=" <span>"+val.toFixed(2)+"</span>";

          if (v.water_need_min) {
            txt+=` (${v.water_need_min} minuti)`;
          }
        }

        // debugger

        if(txt===""){
          txt="-";
        }
        return txt;
      }
    });
  }

  format.push({'field':'irri_auto','label':!auto_irrigation?t('Irrigation')+' (mm)':t('Suggestion')+' (mm)',
    'format': function(d, v){
      var txt="";
      var val=parseFloat(v.water_applied_farmer);
      if(val>0){
        txt+=" <span class='irri_manual'>"+val.toFixed(2)+"</span>";
      }
      val=parseFloat(v.water_applied_auto);
      if(val>0){
        txt+=" <span class='irri_auto'>"+val.toFixed(2)+" ("+('Auto')+")</span>";
      }

      if(txt===""){
        txt="-";
      }
      return txt;
    }
  });

  format.push({'field':'deficit','label':('Deficit')+' (mm)',
    'format': function(d, v){
      var val=parseFloat(d);
      var title=("Roots")+": "+parseFloat(v.root_length).toFixed(2)+"mm,  "+("Total Water available")+": "+parseFloat(v.water_available).toFixed(0)+"mm. ";
      title+=" "+("The optimal water level is")+": "+parseFloat(v.low_threshold).toFixed(2)+"mm";
      title+=" "+("The critical water level is")+": "+parseFloat(v.up_threshold).toFixed(2)+"mm";

      var txt="<span data-toggle='tooltip' title='"+title+"'>"+val.toFixed(2)+"</span>";
      return txt;
    }
  });

  var button="<button class='btn btn-info btn-sm download_csv'><span class='glyphicon glyphicon glyphicon-align-justify'></span>  "+("Download")+"</button>";
  var html=button+'<table class="table table_dashboard">';
  if(data.length>0){
    html+="<thead><tr>";
    jQuery.each(format, function(k,v){
      console.log(v);
      html+="<th>"+v.label+"</th>";
    });
    html+="</tr></thead>";
  }
  html+="<tbody>";

  //For each record of the table (by the bottom)
  d3.map(data, function(v){
    html+="<tr>";
    //For each field in the format
    jQuery.each(format, function(k,f){

      //take the value

      var txt=v[f.field];
      if(typeof f.field =='function'){
        txt=f.field(v);
      }
      else{
        var v2="";
        if(typeof f.format =='function'){
          txt=f.format(txt, v);
        }
        else{
          if(typeof v2=='number'){
            if(v2>0 && v2<1){
              txt=v2.toFixed(4);
            }
            else{
              txt=v2.toFixed(1);
            }
          }
        }
      }
      html+="<td>"+txt+"</td>";
    });
    html+="</tr>";
  });
  html+="</tbody></table>";
  jQuery(div).html(html);

  jQuery(div+ ' .download_csv').click(function(){
    getCSV(div+' table','export.csv');
  });
}

function reverseArr(input) {
  var ret = [];
  for(var i = input.length-1; i >= 0; i--) {
      ret.push(input[i]);
  }
  return ret;
}

export function drawChart(data,div){
  // console.log(d3);
  console.log(data);
  jQuery.each(data,function(k,v){
    // debugger
    console.log(v);
    v.datetime=v.date;
  });

  console.log(d3.version);


  var chart = c3.generate({
    bindto: '#'+div,
    padding: {
      right: 40,
    },
    data: {
      x:'datetime',
      json:data,
      keys:{
        value:['datetime','deficit','opt_thr_mm','cri_thr_mm','rain','water_applied_auto','water_applied_farmer']
      },
      names: {
        deficit: t('Deficit'),
        opt_thr_mm: t('Soglia ottimale'),
        cri_thr_mm: t('Soglia di intervento'),
        rain: t('Pioggia giornaliera'),
        water_applied_auto: t('Irrigazione automatica'),
        water_applied_farmer: t('Irrigazione manuale')
      },
      axes: {
        deficit: 'y',
        opt_thr_mm: 'y',
        cri_thr_mm: 'y',
        rain: 'y'
      },
      colors: {
        deficit: '#1a237e',
        opt_thr_mm: '#40A940',
        cri_thr_mm: '#DA3C3D',
        rain: '#1F77B4',
        water_applied_auto: '#b2ebf2',
        water_applied_farmer: '#90caf9',
      },
      type:'spline',
      types:{
        rain:'bar',
        water_applied_auto:'bar',
        water_applied_farmer:'bar'
      }
    },
    bar: {
      width: {
          ratio: 0.1 // this makes bar width 50% of length between ticks
      }
    },
    point: {
     show: false
    },
    subchart: {
      show: true
    },
    axis : {
      x : {
        type : 'timeseries',
        tick: {
          count:5,
          format: '%d/%m/%Y'
        },
      },
      y:{
        label: '(mm)'
      },
      // y2: {
      //   show: true,
      //   label: 'Pioggia (mm)'
      // }
    }
  });

  return chart;
}
